import React from 'react';

import { CustomerPicker } from '@erp/customers/components/CustomerPicker';
import type { Customer } from '@store/slices/posCustomersSlice.tsx';
import type { PosCustomerBalanceSummary } from '../../types';

export interface PosCustomerControlProps {
  customerId: number | null;
  recentCustomerId?: number | null;
  customer: Customer | null;
  isHydrating: boolean;
  balance?: PosCustomerBalanceSummary | null;
  balanceIsLoading?: boolean;
  onChange: (id: number | null) => void;
  onSelectCustomer: (customer: Customer | null) => void;
  onClearCustomer: () => void;
}

export const PosCustomerControl: React.FC<PosCustomerControlProps> = ({
  customerId,
  recentCustomerId,
  customer,
  isHydrating,
  balance,
  balanceIsLoading,
  onChange,
  onSelectCustomer,
  onClearCustomer,
}) => (
  <div className="pos-screen__customer-control">
    <CustomerPicker
      value={customerId}
      recentCustomerId={recentCustomerId}
      customer={customer}
      onChange={onChange}
      isHydrating={isHydrating}
      balance={balance}
      balanceIsLoading={balanceIsLoading}
      onSelectCustomer={onSelectCustomer}
      onClearCustomer={onClearCustomer}
    />
  </div>
);

export default PosCustomerControl;
